import React from 'react'

import {EventsIndex} from '@src/modules/Events/router/screens/Index'

interface LocationEventsIndexProps {
  hideNewEventButton?: boolean
}

function LocationEventsIndex({hideNewEventButton}: LocationEventsIndexProps) {
  return (
    <div className="relative">
      <EventsIndex hideNewEventButton={hideNewEventButton} />
    </div>
  )
}

export {LocationEventsIndex}
